import { hasPermission } from '@hq/permission';
import { SystemDictPage } from '@hq/sys-admin';
import { hq } from '../api/client';
import { useAuthStore } from '../stores/auth';

/**
 * 数据字典：平台字典（tenant_id=0）+ 本院字典，前端枚举的兜底来源。
 * 页面实现收敛在 `@hq/sys-admin`（ops / system / hospital 共用同一份，权限判定由端内注入）。
 */
export default function SystemDict() {
  const profile = useAuthStore((state) => state.profile);
  const canManage =
    profile?.level === 'admin' || (profile?.perms ? hasPermission(profile.perms, 'sys:config:manage') : false);

  return <SystemDictPage hq={hq} canManage={canManage} />;
}